import { Button, Typography, HorizontalDivider } from '@smartgift/frontend-toolkit';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { GeneralLayout } from '@hero/components/layouts';

import * as S from './style';

function ContinueLogin({ startAuth }) {
  const { t } = useTranslation();

  return (
    <GeneralLayout>
      <S.ContinueLoginContainer>
        <S.Card>
          <Typography style={{ marginBottom: 4 }} variant="subtitle3Bold">
            {t('welcomeToMerchant')}
          </Typography>
          <Typography variant="body1" emphasis="default">
            {t('yourGiftingJourneyBeginsHere')}
          </Typography>
          <HorizontalDivider $margin="24px 0" />
          <Typography style={{ marginBottom: 16 }} variant="body2" color="fg" emphasis="weak">
            {t('clickToContinueDashboard')}
          </Typography>
          <Button onClick={startAuth}>{t('continue')}</Button>
        </S.Card>
      </S.ContinueLoginContainer>
    </GeneralLayout>
  );
}

ContinueLogin.propTypes = {
  startAuth: PropTypes.func
};

export { ContinueLogin };
